import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  doNotCallData,
  contactData,
  doNotCallListData,
  addDoNotCallEntry,
  removeDoNotCallEntry,
} from './../../store/DoNotCall/actionCreator'
import { CircularProgress, TextField, Button } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import HeaderTitle from '../Header/HeaderTitle'
import { Helmet } from 'react-helmet'
import { formValidation } from '../MessageCreate/formValidation'
import DoNotCallItems from '../DoNotCall/DoNotCallItems'
import { arrayOf, shape, bool, string, func, object } from 'prop-types'
import { useOutletContext } from 'react-router-dom'

function withOutletContext(WrappedComponent) {
  return function WrapperComponent(props) {
    const outletContext = useOutletContext()
    return <WrappedComponent {...props} outletContext={outletContext} />
  }
}

const styles = (theme) => ({
  homePage: {
    textAlign: 'center',
  },
  centerDiv: {
    margin: 'auto',
    padding: '0px',
    width: '20%',
    minWidth: 475,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
})

export class DoNotCallPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: this.props.doNotCallEntryListFromParent,
      selectAll: 0,
      doNotCallAddEntry: '',
      doNotCallAddEntryError: true,
      blossomID: this.props.blossomIDFromParent,
    }

    this.setDoNotCallData()
    this.handleChange = this.handleChange.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
  }

  handleChange(event) {
    const target = event.target
    const name = target.name
    const value = target.value

    this.setState({
      [name]: value,
    })
    if (name === 'doNotCallAddEntry') {
      if (
        formValidation(value, 'email', 'boolean') === false ||
        formValidation(value, 'phone', 'boolean') === false
      ) {
        this.setState({
          doNotCallAddEntryError: false,
        })
      } else {
        this.setState({
          doNotCallAddEntryError: true,
        })
      }
    }
  }

  handleDelete = () => {
    let alertWindow = window.confirm(
      'Are you sure you want to delete this entry?',
    )
    if (alertWindow) {
      this.props.deleteTableRow(this.state.selected, this.props.tableName)
    }
    this.setState({ selected: [] })
    this.setState({ selectedId: 0 })
  }

  // New function initial load
  setDoNotCallData() {
    this.props.doNotCallListData(this.state.blossomID)
  }

  removeDoNotCallEntry = (value) => {
    this.props.removeDoNotCallEntry(this.state.blossomID, value)
  }

  addToDoNotCall = (value) => {
    this.props.addDoNotCallEntry(this.state.blossomID, value)
    this.handleReset()
  }

  static defaultProps = {}

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location, doNotCallListData } = this.props
    const { location: nextLocation } = nextProps
    // method to see if the reports need to be refreshed
    if (
      location &&
      nextLocation &&
      nextLocation.pathname &&
      location.pathname &&
      nextLocation.pathname !== location.pathname
    ) {
      this.setState({ blossomID: nextProps.blossomIDFromParent })
      doNotCallListData(nextProps.blossomIDFromParent)
    }
  }

  handleReset = () => {
    this.setState({
      doNotCallAddEntry: '',
    })
    this.setState({ doNotCallAddEntryError: true })
  }

  render() {
    const { classes, headerTitle, responseData, fetchingState } = this.props

    let tableData = ''

    if (responseData === '') {
      tableData = 'No data found in TOM Database'
    } else {
      tableData = (
        <DoNotCallItems
          blossomIDFromParent={this.state.blossomID}
          dataFromParent={responseData}
          callbackFromParentData={this.removeDoNotCallEntry}
          fetchingState={fetchingState}
        />
      )
    }

    // Create variables from values of matching keys
    let toRender = <br />

    if (fetchingState === false && responseData == null) {
      toRender = <br />
    } else if (fetchingState === true) {
      toRender = (
        <div>
          <CircularProgress className={classes.spinner} thickness={7} />
          <h3>loading...</h3>
        </div>
      )
    } else if (responseData != null) {
      toRender = (
        <div className={classes.centerDiv}>
          <TextField
            id="filled-dnc-input"
            label="Enter in DNC Value"
            className={classes.textField}
            name="doNotCallAddEntry"
            InputLabelProps={{
              shrink: true,
            }}
            value={this.state.doNotCallAddEntry}
            onChange={this.handleChange.bind(this)}
            error={this.state.doNotCallAddEntryError}
          />
          <Button
            disabled={this.state.doNotCallAddEntryError}
            onClick={() => {
              this.addToDoNotCall(this.state.doNotCallAddEntry)
            }}
            variant="contained"
            className={classes.button}
          >
            Add to DNC List
          </Button>
          <br />
          {tableData}
        </div>
      )
    }

    return (
      <div className={classes.myBox}>
        <HeaderTitle title="TgtAlerts - Do Not Call" />
        <Helmet>
          <title>{headerTitle}</title>
        </Helmet>
        <div className={classes.homePage}>
          <br />
          {toRender}
        </div>
      </div>
    )
  }
}

DoNotCallPage.propTypes = {}

// Review
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      doNotCallData,
      contactData,
      doNotCallListData,
      addDoNotCallEntry,
      removeDoNotCallEntry,
    },
    dispatch,
  )

// Review
const mapStateToProps = (state) => ({
  responseData: state.contactData.data,
  fetchingState: state.contactData.fetching,
  fetching2State: state.contactData.fetching2,
  headerTitle: state.headerTitle,
})

const DoNotCallPageWithContext = withOutletContext(DoNotCallPage)
const StyledConnectedDoNotCallPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(DoNotCallPageWithContext))

export default StyledConnectedDoNotCallPage

DoNotCallPage.propTypes = {
  doNotCallEntryListFromParent: arrayOf(object),
  blossomIDFromParent: string.isRequired,
  tableName: string,
  deleteTableRow: func,
  doNotCallListData: func,
  removeDoNotCallEntry: func,
  addDoNotCallEntry: func,
  location: shape({
    pathname: string,
  }),
  classes: object,
  headerTitle: string,
  fetchingState: bool,
  responseData: arrayOf(
    shape({
      address: string,
    }),
  ),
}
